import { useCallback, useMemo, useState } from 'react';
import { type AccountModel, QuyenChungTu } from '@/types/schemas';

export interface FormFieldState {
  quyenChungTu: QuyenChungTu | null;
  soChungTu: string;
  loaiChungTu: string;
  tyGia: number;
  taiKhoan: AccountModel | null;
}

export interface FormFieldActions {
  setQuyenChungTu: (quyenChungTu: QuyenChungTu) => void;
  setSoChungTu: (soChungTu: string) => void;
  setLoaiChungTu: (loaiChungTu: string) => void;
  setTyGia: (tyGia: number) => void;
  setTaiKhoan: (taiKhoan: AccountModel) => void;
}

export interface UseFormFieldStateReturn {
  state: FormFieldState;
  actions: FormFieldActions;
}

const initialState: FormFieldState = {
  quyenChungTu: null,
  soChungTu: '',
  loaiChungTu: '1',
  tyGia: 1,
  taiKhoan: null
};

function transformInitialData(initialData?: MuaHangRecord): Partial<FormFieldState> {
  if (!initialData) return {};

  return {
    quyenChungTu: initialData.so_ct_data || null,
    soChungTu: initialData.so_ct || '',
    taiKhoan: initialData.tk_data || null,
    loaiChungTu: initialData.ma_ngv || '1'
  };
}

export function useFormFieldState(initialData?: MuaHangRecord): UseFormFieldStateReturn {
  const [state, setState] = useState<FormFieldState>({
    ...initialState,
    ...transformInitialData(initialData)
  });

  const setQuyenChungTu = useCallback((quyenChungTu: QuyenChungTu) => {
    setState(prev => ({
      ...prev,
      quyenChungTu
    }));
  }, []);

  const setSoChungTu = useCallback((soChungTu: string) => {
    setState(prev => ({ ...prev, soChungTu }));
  }, []);

  const setLoaiChungTu = useCallback((loaiChungTu: string) => {
    setState(prev => ({ ...prev, loaiChungTu }));
  }, []);

  const setTyGia = useCallback((tyGia: number) => {
    setState(prev => ({ ...prev, tyGia }));
  }, []);

  const setTaiKhoan = useCallback((taiKhoan: AccountModel) => {
    setState(prev => ({ ...prev, taiKhoan }));
  }, []);

  const actions: FormFieldActions = useMemo(
    () => ({
      setQuyenChungTu,
      setSoChungTu,
      setLoaiChungTu,
      setTyGia,
      setTaiKhoan
    }),
    [setQuyenChungTu, setSoChungTu, setLoaiChungTu, setTyGia, setTaiKhoan]
  );

  return { state, actions };
}
